export default __webpack_public_path__ + "static/media/640_business02-jp-web.a9578d7d.png";